/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { GetBulkPdfDownloadDto } from '../../models/get-bulk-pdf-download-dto';

export interface GetBulkPdfDownloadState$Params {
  executionId: string;
}

export function getBulkPdfDownloadState(
  http: HttpClient,
  rootUrl: string,
  params: GetBulkPdfDownloadState$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetBulkPdfDownloadDto>> {
  const rb = new RequestBuilder(rootUrl, getBulkPdfDownloadState.PATH, 'get');
  if (params) {
    rb.path('executionId', params.executionId, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetBulkPdfDownloadDto>;
      }),
    );
}

getBulkPdfDownloadState.PATH = '/document/download/{executionId}';
